<style scoped lang="css">
.card {
  cursor: pointer;
}

@media (min-width: 576px) {
  .card {
    min-height: 160px;
  }
}

@media (min-width: 768px) {
  .card {
    min-height: 200px;
  }
}

@media (min-width: 992px) {
  .card {
    min-height: 180px;
  }
}

@media (min-width: 1200px) {
  .card {
    min-height: 200px;
  }
}
</style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-sm--hover mb-3">
        <Header title="" />
        <b-row class="mb-3 px-3">
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToChecklists()">
              <b-card-title>
                Checklists
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Checklists para la entrega de equipos
                </p>
                <b-icon-file-earmark-check scale="3" />
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToTemplates()">
              <b-card-title>
                Hojas de servicio
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Maneja las hojas de servicio.
                </p>
                <b-icon-file-earmark-text scale="3" />
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToChecker()">
              <b-card-title>
                Checador
              </b-card-title>
              <b-card-text class="text-center">
                <p>Checa tu hora de entrada y salida</p>
                <b-icon-clock-history scale="3" />
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToUsers()">
              <b-card-title>
                Usuarios
              </b-card-title>
              <b-card-text class="text-center">
                <p>Manejo de usuarios - Exclusivo para administradores</p>
                <b-icon-person-badge scale="3"></b-icon-person-badge>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToAlarmCodes()">
              <b-card-title>
                C&oacute;digos de alarmas
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Tabla de c&oacute;digos para el operador.
                </p>
                <b-icon-file-ruled scale="3"></b-icon-file-ruled>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToTemperature()">
              <b-card-title>
                Conversi&oacute;n de temperatura
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Convierte la temperatura
                </p>
                <b-icon-calculator-fill scale="3" />
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm" @click="goToContacts()">
              <b-card-title>
                Cont&aacute;ctos
              </b-card-title>
              <b-card-text class="text-center">
                <p>Contactos pr&aacute;cticos</p>
                <b-icon-person-lines-fill scale="3"></b-icon-person-lines-fill>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <Footer />
      </main>
    </section>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  methods: {
    goToChecklists() {
      this.$router.push("/checklists");
    },
    goToTemplates() {
      this.$router.push("/templates");
    },
    goToTemperature() {
      this.$router.push("/temperature");
    },
    goToAlarmCodes() {
      this.$router.push("/codes");
    },
    goToContacts() {
      this.$router.push("/contacts");
    },
    goToChecker() {
      this.$router.push("/checks");
    },
    goToUsers() {
      this.$router.push("/users");
    },
  },
};
</script>
